export default "__VITE_ASSET__BReJ_aZ___"